import { BarChart, BlankSlate, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const CHART_MARGINS = {
  top: 15,
  bottom: 85,
  left: 30,
  right: 20,
} as const

interface Props {
  hasRecords: boolean
}

export const ChartSkeleton: React.FC<Props> = ({ hasRecords }) => {
  const buckets = ['a', 'b', 'c', 'd', 'e'].map((letter, index) => {
    const length = (index + 3) * 2
    return 'x'.repeat(length) + letter
  })

  const scores = [60, 50, 100, 70, 30]

  const data = buckets.map((bucket, index) => {
    const score = scores[index] || 0

    return {
      bucket,
      score,
    }
  })

  return (
    <Box
      position="relative"
      style={{ width: '100%', height: '100%' }}
      justifyContent="center"
      alignItems="center"
    >
      <Box position="absolute" style={{ top: '0', zIndex: '2' }}>
        <BlankSlate
          title={i18n.t('performance_process.analytics.datatable.blank_slate.no_data.title')}
          description={
            hasRecords
              ? i18n.t('performance_process.analytics.datatable.blank_slate.no_data.description')
              : undefined
          }
          illustration="analytics-graph"
          size="small"
        />
      </Box>
      <Box
        style={{
          right: '0',
          left: '0',
          bottom: '0',
          top: '0',
          zIndex: '1',
          opacity: '1',
          background:
            'radial-gradient(circle, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 50%)',
        }}
        position="absolute"
        width="full"
      ></Box>
      <Box style={{ width: '100%', height: '100%', filter: 'blur(3px)' }}>
        <BarChart
          margin={CHART_MARGINS}
          colors={['grey400']}
          maxValue={120}
          keys={['score']}
          indexBy="bucket"
          axisBottom={{
            format: (label: string) => label,
            renderTick: ({ x, y, value }) => (
              <g transform={`translate(${x},${y + 12})`}>
                <text
                  textAnchor="middle"
                  dominantBaseline="middle"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: 9,
                  }}
                >
                  {value}
                </text>
              </g>
            ),
          }}
          enabledGridY
          data={data}
          isInteractive={false}
        />
      </Box>
    </Box>
  )
}
